import { useEffect } from 'react';

const useGlobalPrivacyControl = (setPreferences) => {
  useEffect(() => {
    const checkGPC = () => {
      if (navigator.globalPrivacyControl === true) {
        setPreferences((prev) => ({
          ...prev,
          performance: false,
          targeting: false,
        }));
      }
    };

    checkGPC();

    // Listen for changes in GPC setting
    window.addEventListener('globalPrivacyControlChange', checkGPC);

    return () => {
      window.removeEventListener('globalPrivacyControlChange', checkGPC);
    };
  }, [setPreferences]);
};

export default useGlobalPrivacyControl;